import Vue from "vue"
import VueVariants from "@/mixins/vue-variants"

Vue.use(VueVariants)
